import { UseApi } from '../utils/axios-pettitions';

export async function getServiciosParaFacturar(filtros: {
  cliente_id: number;
  fecha_inicio: string;
  fecha_fin: string;
  show_cantidad?: boolean;
}) {
  try {
    const { runApi } = UseApi();
    const params: any = {
      cliente_id: filtros.cliente_id,
      fecha_inicio: filtros.fecha_inicio,
      fecha_fin: filtros.fecha_fin,
    };
    if (filtros.show_cantidad) {
      params.show_cantidad = true;
    }
    const response = await runApi('facturacion', 'GET', params);
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al obtener los servicios para facturar',
    };
  }
}

export async function marcarFacturados(servicio_ids: number[], accion: 'facturar' | 'desmarcar') {
  try {
    const { runApi } = UseApi();
    const response = await runApi('facturacion', 'PUT', null, {
      servicio_ids,
      accion,
    });
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al actualizar el estado de facturación',
    };
  }
}
